// extracted by mini-css-extract-plugin
export var chevron = "_kj-4";
export var chevronExpanded = "_kj-5";
export var row = "_kj-0";
export var rowBody = "_kj-6";
export var rowDescription = "_kj-7";
export var rowHeader = "_kj-1";
export var rowTitle = "_kj-2";
export var rowTitleComplete = "_kj-3";